import HolLogo from "../assets/img/HOL-logo-header.png";
import InternationalLogo from "../assets/img/agh-logo.png";
import InternationalLogo2x from "../assets/img/agh-logo@2x.png";
import InternationalLogo3x from "../assets/img/agh-logo@3x.png";
import SagaLogo from "../assets/img/saga-logo.png";
import SagaLogo2x from "../assets/img/saga-logo@2x.png";
import SagaLogo3x from "../assets/img/saga-logo@3x.png";
import { RebrandHelper, LogoConstants } from "../helpers/brand/RebrandHelper";

const Header = {
  SagaLink: {
    Class: "",
    ImageClass: "",
    Src: SagaLogo,
    SrcSet: SagaLogo2x + " 2x," + SagaLogo3x + " 3x",
    SrcMin: SagaLogo,
    SrcMinSet: SagaLogo2x + " 2x," + SagaLogo3x + " 3x",
    AltText: "Saga"
  },
  Link: {
    Class: {
      Any: "header-brand col-1",
      International: "header-brand col-1"
    },
    ImageClass: {
      Any: "header-brand-image",
      International: "header-brand-image"
    },
    Src: {
      HOL: HolLogo,
      MOL: RebrandHelper.getAxaLogo(LogoConstants.Logo),
      International: InternationalLogo
    },
    SrcMin: {
      HOL: HolLogo,
      MOL: RebrandHelper.getAxaLogo(LogoConstants.LogoMin),
      International: InternationalLogo
    },
    SrcSet: {
      HOL: HolLogo,
      MOL: RebrandHelper.getAxaLogo(LogoConstants.LogoSet),
      International: InternationalLogo2x + " 2x," + InternationalLogo3x + " 3x"
    },
    SrcMinSet: {
      HOL: HolLogo,
      MOL: RebrandHelper.getAxaLogo(LogoConstants.LogoSetMin),
      International: InternationalLogo2x + " 2x," + InternationalLogo3x + " 3x"
    },
    AltText: {
      HOL: "Health-on-Line",
      MOL: RebrandHelper.getAxaBrandName(),
      International: "AXA"
    }
  },

  HealthSupportText: {
    HOL: "Health hub",
    MOL: "Health support"
  },
  HealthStoreText: {
    HOL: "Customer offers",
    MOL: "Member offers"
  },
  MyProfileLink: {
    Any: "My profile",
    HOL: "My account"
  },
  LogoutLink: "Logout",
  EndSession: "End session",
  LapsedPlan: {
    HOL: "Lapsed Policy",
    MOL: "Lapsed Plan"
  }
};

export default Header;
